import { createFileRoute } from "@tanstack/react-router";

import { studentSearchParamsSchema } from "@/domain/student";
import { StudentsScreen } from "@/interactors/StudentsScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/students/")({
  component: StudentsScreen,
  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "students",
    }),
  validateSearch: studentSearchParamsSchema,
  head: () => headWithCustomTitle("main:students.title"),
});
